<div class="fuse-drawer-content">
    <ng-content />
</div>
